import { Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { Router, NavigationEnd } from '@angular/router';
import { VersionCheckService } from './_services/version-check.service';
import { IdleService } from './idle.service';
import { IdleTimeoutDialogComponent } from './component/idle-timeout-dialog/idle-timeout-dialog.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  timeoutWarningSubscription: Subscription | undefined;

  constructor(
    private readonly versionCheckService: VersionCheckService,
    private readonly idleService: IdleService,
    private readonly dialog: MatDialog,
    private readonly router: Router
  ) {
    // Listen for route changes once, in constructor
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.handleRouteChange(event.urlAfterRedirects);
      }
    });
  }

  ngOnInit(): void {
    this.versionCheckService.checkVersion();
  }

  ngOnDestroy(): void {
    if (this.timeoutWarningSubscription) {
      this.timeoutWarningSubscription.unsubscribe();
    }
    this.idleService.stopIdleTimer();
  }

  @HostListener('document:click')
  resetIdleTimer(): void {
    this.idleService.resetIdleTimer();
  }

  private handleRouteChange(currentUrl: string): void {
    const excludedRoutes = ['/', '', '/#'];

    if (!excludedRoutes.includes(currentUrl)) {
      // Start idle timer only once per session
      if (!this.timeoutWarningSubscription) {
        this.timeoutWarningSubscription = this.idleService.timeoutWarning$.subscribe((timeLeft) => {
          this.openIdleTimeoutDialog(timeLeft);
        });
      }
      this.idleService.startIdleTimer();
    } else {
      this.idleService.stopIdleTimer();

      if (this.timeoutWarningSubscription) {
        this.timeoutWarningSubscription.unsubscribe();
        this.timeoutWarningSubscription = undefined;
      }

      this.idleService.resetIdleTimer(); // Optional but safe
    }

    // Re-enable reCAPTCHA if on login page
    if (currentUrl === '/') {
      this.showRecaptchaBadge();
    }
  }

  private showRecaptchaBadge(): void {
    const styles = document.getElementsByTagName('style');
    for (const style of Array.from(styles)) {
      if (style.innerHTML.includes('.grecaptcha-badge { visibility: hidden; }')) {
        style.remove();
      }
    }
  }

  private openIdleTimeoutDialog(timeLeft: number): void {
    const dialogRef = this.dialog.open(IdleTimeoutDialogComponent, {
      data: { timeLeft },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Dialog closed with result:', result);
      if (result === 'logout') {
        this.idleService.logout();
      } else {
        this.idleService.resetIdleTimer();
      }
    });
  }
}
